import { Card, Stack } from "@mui/material";
import MDTypography from "components/MDTypography";
import React from "react";
import DefaultLineChart from "utils/Charts/LineCharts/DefaultLineChart";

function SelfAssessmentGraph({ graphData }) {
  return (
    <Card sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" mx={3} pr={1}>
        <MDTypography variant="h5">Self Assessment Score</MDTypography>
        <Stack direction="row" spacing={1}>
          <MDTypography variant="h5">Average</MDTypography>
          <MDTypography variant="h5" sx={{ color: "#50c70c" }}>
            {`${graphData.average || "0.00"}`}
          </MDTypography>
        </Stack>
      </Stack>
      <DefaultLineChart height="17vh" chart={graphData} />
    </Card>
  );
}

export default SelfAssessmentGraph;
